"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_platform = require("@hcengineering/platform");
var import_contact = __toESM(require("@hcengineering/contact"));
const icons = require("../assets/icons.svg");
(0, import_platform.loadMetadata)(import_contact.default.icon, {
  ContactApplication: `${icons}#contactapplication`,
  Phone: `${icons}#phone`,
  Teron: `${icons}#teron`,
  Email: `${icons}#email`,
  Discord: `${icons}#discord`,
  Facebook: `${icons}#facebook`,
  Instagram: `${icons}#instagram`,
  LinkedIn: `${icons}#linkedin`,
  Telegram: `${icons}#telegram`,
  Google: `${icons}#google`,
  Twitter: `${icons}#twitter`,
  VK: `${icons}#vk`,
  Viber: `${icons}#viber`,
  WhatsApp: `${icons}#whatsapp`,
  Skype: `${icons}#skype`,
  Youtube: `${icons}#youtube`,
  GitHub: `${icons}#github`,
  Edit: `${icons}#edit`,
  Person: `${icons}#person`,
  Persona: `${icons}#persona`,
  Company: `${icons}#company`,
  SocialEdit: `${icons}#social-edit`,
  Homepage: `${icons}#homepage`,
  Whatsapp: `${icons}#whatsapp`,
  Profile: `${icons}#profile`,
  KickUser: `${icons}#kickUser`,
  ComponentMembers: `${icons}#componentMembers`,
  Contacts: `${icons}#contacts`,
  Clock: `${icons}#clock`,
  Chat: `${icons}#chat`,
  User: `${icons}#user`
});
(0, import_platform.addStringsLoader)(import_contact.contactId, async (lang) => await import(`../lang/${lang}.json`));
const ProfileBackground = require("../assets/profile-background.png");
const ProfileBackgroundLight = require("../assets/profile-background-light.png");
(0, import_platform.loadMetadata)(import_contact.default.image, {
  ProfileBackground,
  ProfileBackgroundLight
});
//# sourceMappingURL=index.js.map
